import { useEffect, useState } from "react";

const FileImage = ({ file, ...props }) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        if (!file) {
            setUrl(null);
            return;
        }

        // File or Blob
        if (file instanceof Blob) {
            const objectUrl = URL.createObjectURL(file);
            setUrl(objectUrl);

            return () => URL.revokeObjectURL(objectUrl);
        }

        // String URL or base64 data URL
        if (typeof file === "string") {
            setUrl(file);
            return;
        }

        // Unsupported type
        setUrl(null);
    }, [file]);

    if (!url) return null;

    return <img src={url} {...props} />;
};

export default FileImage;